
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import EditorPageLayout from "../../common/editor/EditorPageLayout";
import Form from "./form/Form";

export default function PublicationEdit() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const params = useParams();
	const publicationId = params.publicationId;
	const [publication, setPublication] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	useEffect(() => {
		setIsLoading(true);
		api.publicationFetchEdit({
			token: LoginHelper.getToken(),
			publication_id: publicationId,
		}).then((result) => {
			setPublication(result);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}, [publicationId]);

	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'مقالات', href: '/publication_list/' },
		{ label: 'ویرایش مقاله' },
	];

	return (
		<EditorPageLayout
			isDesktop={isDesktop}
			pageTitle="ویرایش مقاله"
			metaDescription="ویرایش مقاله در همراهتیم"
			breadcrumbLinks={linkDataList}
			wide
			isLoading={isLoading}
			loadError={errorMessage && !publication ? errorMessage : ""}
		>
			{publication && <Form publication={publication} />}
		</EditorPageLayout>
	);
}
